module.exports = __webpack_public_path__ + "img/conference10.c9449a82.jpg";